import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

import { DESTINY, ORIGIN } from 'config/stockTypes'

const StockSelect = ({
  destiny = false,
  onChange = () => {},
  placeholder = '',
  translate = () => {},
  value = [destiny ? DESTINY.C010.value : ORIGIN.C010.value],
}) => {
  const getOption = (option) => {
    const stock = option[1]

    return { label: translate(stock.label), value: stock.value }
  }

  const options = Object.entries(destiny ? DESTINY : ORIGIN).map(getOption)

  return (
    <Select
      className='react-select react-select-multi'
      classNamePrefix='react-select'
      closeMenuOnSelect={false}
      isMulti
      onChange={(s) => onChange(s ? s.map((o) => o.value) : [])}
      options={options}
      placeholder={placeholder}
      value={options.filter((option) => value.some((v) => v === option.value))}
    />
  )
}

StockSelect.propTypes = {
  destiny: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  translate: PropTypes.func,
  value: PropTypes.array,
}

export default StockSelect
